import { injectable, inject } from 'inversify';
import { CommandHandler } from '@/app/tracking/api';
import { parseStatus, CompletionStatus } from '@/app/tracking/scorm/2004/api';
import { ErrorHandlingScorm2004Client, ErrorHandlingScorm2004ClientSymbol } from '@/app/tracking/scorm/2004/client';
import { StartCourseCommand } from '../api';

@injectable()
export class Scorm2004StartCourseCommandHandler implements CommandHandler<StartCourseCommand> {

  constructor(
    @inject(ErrorHandlingScorm2004ClientSymbol)
    private readonly client: ErrorHandlingScorm2004Client) {
  }

  public async execute() {

    this.client.initialize()
    
    const completionStatusResult = await this.client.getValue('cmi.completion_status');
    if (completionStatusResult.success) {
      const completionStatus = parseStatus(completionStatusResult.value);
      if (completionStatus.success &&
            [ CompletionStatus.unknown, CompletionStatus.notAttempted ].indexOf(completionStatus.value) >= 0) {

        this.client.setValue('cmi.completion_status', 'incomplete');
      }
    }

    this.client.setValue('cmi.exit', 'suspend');
    this.client.commit();
  }

}
